export enum OrganizationStatus {
  Inactive = "Inactive",
  Pending = "Pending",
  Active = "Active",
}
